module.exports = __webpack_public_path__ + "img/saum_himmelblau_ral5015.7b9aebb8.jpg";